import client from './client';
import type { VPNKey } from '../types/vpnkey';

export async function getMyKeys(): Promise<VPNKey[]> {
  const { data } = await client.get('/vpn/keys');
  return data || [];
}

export async function renameKey(keyId: string, deviceName: string): Promise<VPNKey> {
  const { data } = await client.patch(`/vpn/keys/${keyId}/name`, { deviceName });
  return data;
}

/** Отвязать устройство от ключа: следующее приложение, вставившее ключ, станет новым. */
export async function unbindKeyDevice(keyId: string): Promise<void> {
  await client.delete(`/vpn/keys/${keyId}/device`);
}

export function getQRCodeUrl(keyId: string): string {
  const baseURL = import.meta.env.VITE_API_URL || 'http://localhost:8080';
  return `${baseURL}/api/v1/vpn/keys/${keyId}/qr`;
}
